import { mainColor, UNIT } from '../../constants/theme'

export const styles = () => ({
    gutters: {
        paddingLeft: 30,
        paddingRight: 30
    },
    configText: {
        color: mainColor.colorBlack,
        marginLeft: -UNIT
    },
    listStyle: {
        marginTop: -UNIT * 2.0625,
        marginBottom: -UNIT * 0.4375,
        borderTopRightRadius: UNIT
    },
    designText: {
        fontSize: UNIT * 0.875,
        fontWeight: 'bold',
        alignSelf: 'center',
        paddingBottom: '5px'
    },
    inputRow: {
        display: 'flex',
        alignItems: 'center'
    },

    equalsSign: {
        margin: '0 10px',
        marginTop: UNIT * 0.4375
    },
    iconStyle: {
        marginLeft: -UNIT * 0.875,
        cursor: 'pointer'
    },
    textStyle: {
        fontSize: UNIT * 0.75,
        color: '#a19c9c!important'
    },
    leftArrow: {
        marginRight: UNIT * -1.4375,
        color: mainColor.colorBlack,
        cursor: 'pointer'
    },
    icon: {
        marginLeft: -UNIT * 1.3125,
        color: '#a19c9c',
        cursor: 'pointer'
    },
    version: {
        fontSize: UNIT * 0.8125,
        fontWeight: 'bolder',
    },
    menu: {
        border: '1px solid #f3efef',
        borderRadius: UNIT,
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '371px'
    },
    versionPart: {
        marginLeft: -UNIT * 1.4375,
        fontSize: UNIT * 0.8125,
        fontWeight: 'bolder',
        color: mainColor.colorBlack
    },
    updateIcon: {
        marginRight: UNIT * -0.5,
        color: 'rgba(0, 0, 0, 0.54)',
        cursor: 'pointer'
    },
    checkboxContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    addIcon: {
        fontSize: UNIT * 1.4375, marginRight: -UNIT * 1.3125,
        cursor: 'pointer',
        marginLeft: UNIT * 1.125,
        color: mainColor.secondaryColor
    },
    titleStyle: {
        fontSize: UNIT * 0.875,
        color: 'black'
    },
    paper: {
        marginTop: -UNIT * 0.25
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5
    },
    container: {
        height: UNIT * 18,
        overflowY: 'auto'
    },
    pointBorderTop: {
        borderTopLeftRadius: UNIT,
        borderTopRightRadius: UNIT
    },
    pointBorderBottom: {
        borderBottomLeftRadius: UNIT,
        borderBottomRightRadius: UNIT
    },
    palier: {
        color: mainColor.colorBlack, width: UNIT * 11.25, marginTop: 0
    },
    list: {
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: UNIT
    },
    top: {
        marginTop: UNIT * -0.5
    },
    default: {
        fontSize: UNIT * 0.6875,
        marginTop: 0,
        color: '#999696'
    },
    sectionHeader: {
        background: 'white',
        fontStyle: 'normal',
        fontWeight: 600,
        color: '#858585'
    },
    switch: {
        marginRight: UNIT * -0.75
    }
});
